import { getNewsMediaPulseTracker } from "..";
import { capitalizeFirstLetter } from "../../utils/capitalizeFirstLetter";

const trackViewFrontpage = (id: string) => {
  const newsMediaPulseTracker = getNewsMediaPulseTracker();

  newsMediaPulseTracker?.executeNewsMediaPulseCommand("trackViewFrontpage", {
    object: {
      id: id,
      name: capitalizeFirstLetter(id),
    },
  });
};

export { trackViewFrontpage };
